<template>
<navigation-layout ref='navigationlayout'>
  <h1 slot="title">{{title}}</h1>
  <h3 slot="abstract">{{abstract}}</h3>
  <main>
  <div>
    <md-list>
      <md-list-item @click="selectfacility(facility)" v-for="(facility, index) in facilities" :key="index">
          <md-icon class="md-primary" v-if="isSelected(facility.id)">star</md-icon>
          <img class="facility-logo" v-if="facility.logoUrl" :src=facility.logoUrl :alt=facility.companyName>
        <div class="md-list-item-text">
          <span>{{facility.companyName}}</span>
          <p>{{facility.name}}</p>
        </div>
      </md-list-item>
    </md-list>
  </div>
  </main>
</navigation-layout>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import NotificationService from '@/services/notificationService'
import router from '@/router'

export default {
  name: 'select-billing-company',
  data: () => ({
    facilities: null,
    title: 'Select billing company',
    abstract: 'Here you can select the billing company to manage'
  }),
  components: { NavigationLayout },
  methods: {
    async selectfacility (selectedBillingCompany) {
      await NotificationService.manageNotification(this, RepositoryService.loginAdminFacility(selectedBillingCompany), this.callback)
    },
    callback () {
      if (this.$route.query && this.$route.query.redirect) {
        router.push({ path: this.$route.query.redirect })
      } else {
        router.push({ name: 'searchfacility' })
      }
    },
    isSelected (facilityId) {
      if (RepositoryService.session.selectedBillingCompany !== null && RepositoryService.session.selectedBillingCompany !== undefined) {
        if (RepositoryService.session.selectedBillingCompany.id === facilityId) {
          return true
        }
      }
      return false
    }
  },
  created: function () {
    if (!this.facilities) {
      if (!RepositoryService.session.billingCompanies) {
        router.push({ name: 'login' })
      } else {
        this.facilities = RepositoryService.session.billingCompanies
      }
    }
  }
}
</script>

<style>
  .facility-logo{
    max-width: 110px;
    max-height: 50px;
    vertical-align: middle;
    margin-right: 20px;
  }
</style>
